import { useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { CSSTransition } from "react-transition-group";

import style from "./Header.module.css";
import popup from "./Popup.module.css";

import Inbound from "../components/Inbound";

export default () => {
  const inbound = useRef<HTMLDivElement | null>(null);
  const [openInbound, setOpenInbound] = useState<boolean>(false);
  const [openMenu, setOpenMenu] = useState<boolean>(false);

  useEffect(() => {
    document.body.style.overflow = openInbound || openMenu ? "hidden" : "auto";
  }, [openInbound, openMenu]);

  useEffect(() => {
    const handleOpen = () => setOpenInbound(true);
    const handleClose = () => setOpenInbound(false);

    window.addEventListener("inbound:open", handleOpen);
    window.addEventListener("inbound:close", handleClose);

    return () => {
      window.removeEventListener("inbound:open", handleOpen);
      window.removeEventListener("inbound:close", handleClose);
    };
  }, []);

  return (
    <>
      <div className={style["container"]}>
        <div className={style["wrapper"]}>
          <div className={style["unit"]}>
            <a href="/" className={style["button--logo"]}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="115"
                    height="30"
                    viewBox="0 0 115 30"
                    fill="#ffffff"
                >
                    <path d="M26.0072 0H8.66867L0 15L8.66867 30H26.0072L34.6759 15L26.0072 0ZM23.4424 27.3171H16.9723C16.4328 27.3171 15.9957 26.8805 15.9957 26.3415C15.9957 25.8024 16.4328 25.3659 16.9723 25.3659H23.4424C23.982 25.3659 24.419 25.8024 24.419 26.3415C24.419 26.8805 23.982 27.3171 23.4424 27.3171ZM23.4424 23.5366H19.5359C18.9964 23.5366 18.5593 23.1 18.5593 22.561C18.5593 22.022 18.9964 21.5854 19.5359 21.5854H23.4424C23.982 21.5854 24.419 22.022 24.419 22.561C24.419 23.1 23.982 23.5366 23.4424 23.5366ZM23.3814 12.1951H16.8503V17.8049H23.4424C23.982 17.8049 24.419 18.2415 24.419 18.7805C24.419 19.3195 23.982 19.7561 23.4424 19.7561H15.7516C15.212 19.7561 14.775 19.3195 14.775 18.7805C14.775 18.7707 14.775 18.7622 14.7762 18.7537C14.7762 18.7451 14.775 18.7354 14.775 18.7268V12.1963H11.1737C10.6011 12.1963 10.136 11.7317 10.136 11.1598C10.136 10.5878 10.6011 10.1232 11.1737 10.1232H23.3814C23.9539 10.1232 24.419 10.5878 24.419 11.1598C24.419 11.7317 23.9539 12.1963 23.3814 12.1963V12.1951ZM24.419 15C24.419 15.539 23.982 15.9756 23.4424 15.9756H19.5359C18.9964 15.9756 18.5593 15.539 18.5593 15C18.5593 14.461 18.9964 14.0244 19.5359 14.0244H23.4424C23.982 14.0244 24.419 14.461 24.419 15ZM23.4424 8.41463H19.5359C18.9964 8.41463 18.5593 7.97805 18.5593 7.43902C18.5593 6.9 18.9964 6.46341 19.5359 6.46341H23.4424C23.982 6.46341 24.419 6.9 24.419 7.43902C24.419 7.97805 23.982 8.41463 23.4424 8.41463ZM23.3814 4.69512H17.0334C16.4608 4.69512 15.9957 4.23049 15.9957 3.65854C15.9957 3.08659 16.4608 2.62195 17.0334 2.62195H23.3814C23.9539 2.62195 24.419 3.08659 24.419 3.65854C24.419 4.23049 23.9539 4.69512 23.3814 4.69512Z" />
                    <path d="M41.2656 4.14634V5.36585H42.9747V11.2195H44.4396V5.36585H46.1487V4.14634H41.2656Z" />
                    <path d="M51.2756 4.14634V6.82927H48.712V4.14634H47.2471V11.2195H48.712V8.04878H51.2756V11.2195H52.7405V4.14634H51.2756Z" />
                    <path d="M58.967 5.36585V4.14634H55.5489C54.875 4.14634 54.3281 4.69268 54.3281 5.36585H54.3342C54.3306 5.4061 54.3281 5.44634 54.3281 5.4878V11.2195H58.967V10H55.671V8.04878H58.6008V6.82927H55.671V5.36585H58.967Z" />
                    <path d="M48.5458 16.9134V15H43.183C42.1246 15 41.2676 15.8561 41.2676 16.9134H41.2773C41.2712 16.9768 41.2676 17.0402 41.2676 17.1049V26.0976H48.5458V24.1841H43.3746V21.1232H47.972V19.2098H43.3746V16.9134H48.5458Z" />
                    <path d="M94.9354 16.9134V15H89.5726C88.5142 15 87.6572 15.8561 87.6572 16.9134H87.667C87.6609 16.9768 87.6572 17.0402 87.6572 17.1049V26.0976H94.9354V24.1841H89.7643V21.1232H94.3617V19.2098H89.7643V16.9134H94.9354Z" />
                    <path d="M104.336 16.9134V15H98.973C97.9146 15 97.0576 15.8561 97.0576 16.9134H97.0674C97.0613 16.9768 97.0576 17.0402 97.0576 17.1049V26.0976H104.336V24.1841H99.1647V21.1232H103.762V19.2098H99.1647V16.9134H104.336Z" />
                    <path d="M56.7698 15V22.6122L56.7418 22.5817L53.7338 15.6659C53.558 15.261 53.1588 15 52.7169 15H51.2764C51.0066 15 50.7881 15.2183 50.7881 15.4878V26.0976H52.9855V18.9061L55.8238 25.4317C55.9898 25.8146 56.3572 26.0659 56.7698 26.0927V26.0976H58.4789C58.7487 26.0976 58.9672 25.8793 58.9672 25.6098V15H56.7698Z" />
                    <path d="M83.0159 15V22.6122L82.9879 22.5817L79.9799 15.6659C79.8041 15.261 79.4049 15 78.963 15H77.5225C77.2527 15 77.0342 15.2183 77.0342 15.4878V26.0976H79.2316V18.9061L82.0698 25.4317C82.2359 25.8146 82.6033 26.0659 83.0159 26.0927V26.0976H84.725C84.9948 26.0976 85.2133 25.8793 85.2133 25.6098V15H83.0159Z" />
                    <path d="M74.4707 26.0976V15H72.2733V26.0976H74.4707Z" />
                    <path d="M69.9536 19.0244H65.3147V20.9756H67.7562V24.2683H63.7277V16.9512H69.3432V15H63.2394C62.2957 15 61.5303 15.7646 61.5303 16.7073V16.9512H61.5449C61.5364 17.0317 61.5303 17.1122 61.5303 17.1951V23.9024C61.5303 24.0268 61.5437 24.1488 61.5632 24.2683H61.5303V24.3902C61.5303 25.3329 62.2957 26.0976 63.2394 26.0976H68.2445C69.1882 26.0976 69.9536 25.3329 69.9536 24.3902V24.2683H69.9206C69.9401 24.1488 69.9536 24.0268 69.9536 23.9024V19.0244Z" />
                    <path d="M112.895 21.6037C113.901 21.3024 114.634 20.3707 114.634 19.2683V17.439C114.634 16.0915 113.542 15 112.193 15H106.577V26.0976H108.775V21.7073H110.746L112.803 26.0976H115L112.895 21.6037ZM112.498 18.7195C112.498 19.3927 111.951 19.939 111.277 19.939H108.775V16.7683H111.277C111.951 16.7683 112.498 17.3146 112.498 17.9878V18.7195Z" />
                </svg>
            </a>

            <div
              className={[style["list"], openMenu && style["active"]].join(" ")}
              onClickCapture={(e) => {
                if (openMenu) {
                  const el = e.target as HTMLElement;
                  if (el.closest("a")) setOpenMenu(false);
                }
              }}
            >
              {/* 드롭다운 */}
              <div className={style["dropdown"]}>
                <a
                    href="/#"
                    className={style["dropdown__toggle"]}
                    onClick={(e) => {
                        if (window.matchMedia("(max-width: 833px)").matches) {
                        e.preventDefault(); // 모바일에선 드롭다운 막음
                        return;
                        }
                    }}
                >
                    About us
                </a>

                <div className={`${style["dropdown__menu"]} ${style["hide-mobile"]}`}>
                  <a
                    href="/framework"
                    style={{ padding: "14px 18px" }}
                    className={style["dropdown__item"]}
                  >
                    Framework
                  </a>
                  <a
                    href="/solution"
                    style={{ padding: "14px 18px" }}
                    className={style["dropdown__item"]}
                  >
                    Solutions
                  </a>
                  <a
                    href="/location"
                    style={{ padding: "14px 18px" }}
                    className={style["dropdown__item"]}
                  >
                    Locations
                  </a>
                  <a
                    href="/mission"
                    style={{ padding: "14px 18px" }}
                    className={style["dropdown__item"]}
                  >
                    Join us
                  </a>
                  <a
                    href="/videos"
                    style={{ padding: "14px 18px" }}
                    className={style["dropdown__item"]}
                  >
                    Videos
                  </a>
                </div>
                <div className={`${style["dropdown__inlineMobile"]} ${style["only-mobile"]}`}>
                    <a href="/framework" className={style["dropdown__item"]}>Framework</a>
                    <a href="/solution" className={style["dropdown__item"]}>Solutions</a>
                    <a href="/location" className={style["dropdown__item"]}>Locations</a>
                    <a href="/mission" className={style["dropdown__item"]}>Join us</a>
                    <a href="/videos" className={style["dropdown__item"]}>Videos</a>
                </div>
              </div>

              {/* 외부 링크 */}
              <a href="https://www.fa-job.com/" target="_blank">
                FAJOB
              </a>
              <a href="https://xconcepai.com/" target="_blank">
                X concep AI
              </a>
              <a
                href="https://www.youtube.com/@theengineerfajob"
                target="_blank"
              >
                YouTube
              </a>
              <a href="https://blog.naver.com/the-engineer" target="_blank">
                Blog
              </a>
              <a
                href="https://smartstore.naver.com/the-engineer"
                target="_blank"
              >
                Market
              </a>

            </div>

            {/* 햄버거 버튼 */}
            <button
              className={[style["menu"], openMenu && style["active"]].join(" ")}
              onClick={() => setOpenMenu((prev) => !prev)}
            >
              <span>
                <span className={style["top"]}></span>
              </span>
              <span>
                <span className={style["middle"]}></span>
              </span>
              <span>
                <span className={style["bottom"]}></span>
              </span>
            </button>
          </div>

          {/* 문의하기 / LAB ENGINEER 버튼 */}
          <div className={style["action-group"]}>
            <a
              className={style["button--action"]}
              onClick={() => setOpenInbound(true)}
            >
              솔루션 문의하기
            </a>
            <a
              href="https://gpt.theengineer.co.kr/"
              target="_blank"
              rel="noopener noreferrer"
              className={style["button--action"]}
            >
              LAB ENGINEER
            </a>
          </div>
        </div>
      </div>

      {/* 문의하기 팝업 */}
      {createPortal(
        <CSSTransition
          in={openInbound}
          timeout={400}
          classNames="popup-fade"
          unmountOnExit
          nodeRef={inbound}
        >
          <div
            className={popup["div--popup"]}
            ref={inbound}
            onClick={(e) => {
              if (
                document.querySelector(".container-sheet")?.contains(e.target as Node)
              )
                return;
              setOpenInbound(false);
            }}
          >
            <div className={`${popup["container--popup"]} container-sheet`}>
              <button
                className={popup["button--popup"]}
                onClick={() => setOpenInbound(false)}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="#D6D6D6"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M16 7.51H10.25V1.75C10.25 1.35218 10.092 0.970644 9.81066 0.68934C9.52936 0.408035 9.14782 0.25 8.75 0.25C8.35218 0.25 7.97064 0.408035 7.68934 0.68934C7.40804 0.970644 7.25 1.35218 7.25 1.75V7.5H1.5C1.10218 7.5 0.720644 7.65804 0.43934 7.93934C0.158035 8.22064 0 8.60218 0 9C0 9.39782 0.158035 9.77936 0.43934 10.0607C0.720644 10.342 1.10218 10.5 1.5 10.5H7.25V16.25C7.25 16.6478 7.40804 17.0294 7.68934 17.3107C7.97064 17.592 8.35218 17.75 8.75 17.75C9.14782 17.75 9.52936 17.592 9.81066 17.3107C10.092 17.0294 10.25 16.6478 10.25 16.25V10.5H16C16.3978 10.5 16.7794 10.342 17.0607 10.0607C17.342 9.77936 17.5 9.39782 17.5 9C17.5 8.60218 17.342 8.22064 17.0607 7.93934C16.7794 7.65804 16.3978 7.5 16 7.5V7.51Z" />
                </svg>
              </button>
              <div className={popup["wrapper--popup--inbound"]}>
                <Inbound />
              </div>
            </div>
          </div>
        </CSSTransition>,
        document.body
      )}
    </>
  );
};
